const workerCode = `
let intervalId = null;
let timeoutId = null;
self.onmessage = function(event) {
  const { type, time } = event.data;
  if (type === 'setInterval') {
    if(intervalId) clearInterval(intervalId);
    intervalId = setInterval(() => {
      self.postMessage('interval');
    }, time);
  } else if (type === 'clearInterval') {
    clearInterval(intervalId);
  } else if (type === 'setTimeout') {
    if(timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      self.postMessage('timeout');
    }, time);
  } else if (type === 'clearTimeout') {
    clearTimeout(timeoutId);
  }
};
`;

const blob = new Blob([workerCode], { type: 'application/javascript' });

export class WsTimer {
    private handler: Worker;
    private objURL: string;

    constructor(from?: string) {
        console.log('WsTimer', from);
        this.objURL = URL.createObjectURL(blob);
        this.handler = new Worker(this.objURL);
    }

    destroy() {
        try {
            this.handler.terminate();
            URL.revokeObjectURL(this.objURL);
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * 开启循环定时器
     * @param callback 回调
     * @param time 间隔
     */
    startLoop(callback: () => void, time = 1000) {
        this.handler.postMessage({ type: 'setInterval', time });
        this.handler.onmessage = function (event) {
            if (event.data === 'interval') {
                callback();
            }
        };
    }
    /**
     * 结束循环定时器
     */
    stopLoop() {
        this.handler.postMessage({ type: 'clearInterval' });
    }

    /**
     * 开启普通定时器
     * @param callback 回调
     * @param time 间隔
     */
    start(callback: () => void, time = 1000) {
        this.handler.postMessage({ type: 'setTimeout', time });
        this.handler.onmessage = function (event) {
            if (event.data === 'timeout') {
                callback();
            }
        };
    }

    /**
     * 结束普通定时器
     */
    stop() {
        this.handler.postMessage({ type: 'clearTimeout' });
    }
}
